<template>
	<div>
		<h1 class="page-title title no-border">{{ $t("deposit.header") }}</h1>
		<div class="page-ct">
			<h4 class="title">{{ $t("deposit.title.transfer_payment") }}</h4>
				<div class="section">
				<div class="alert alert-danger" v-if="errorMessageVirtual">
					<div v-html="$t(errorMessageVirtual)"></div>
				</div>
					<div class="section-inner">
						<hr class="border-light">
						<div>
							<p style="text-align: center">
								{{ $t("label.deposit.confirm_acc_virtual") }}
							</p>
						</div>

						<div style="padding-bottom: 3% !important; text-align: center">
							<a type="button" class="btn btn-padding-lg btn-green mr-1" @click="requestVirtualAccount()">
								{{ $t("btn.ok") }}
							</a>
							<a type="button" class="btn btn-padding-lg btn-default ml-1" @click="cancelRequestVirtualAccount()">
								{{ $t("btn.change.login.id.cancel") }}
							</a>
						</div>
					</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    data() {
        return {
            SERVICE_NAME: "deposit",
            errorMessageVirtual: null,
            hasVirtualAccount: null
        }
    },
    created() {
        this.initVirtualAccount();
    },
    methods: {
        initVirtualAccount: function () {
            this.$service.getService(this.SERVICE_NAME).checkVirtualBank().then((result) => {
                if (result) {
                    if (result.hasVirtualAccount) {
                        this.hasVirtualAccount = result.hasVirtualAccount;
                        this.$router.push({name: "deposit"});
                    } else {
                        this.errorMessageVirtual = result.errorMessage;
                    }
                } else {
                    this.errorMessageVirtual = "error.happen";
                }
            })
        },
        requestVirtualAccount: function () {
            this.errorMessageVirtual = null;
            if (!this.hasVirtualAccount) {
                this.$service.getService(this.SERVICE_NAME).createVirtualBank().then((result) => {
                    if (result) {
                        if (result.errorMessage == null) {
                            this.$router.push({name: 'deposit', query: {"msg": result.successMessage}});
                        } else {
                            this.errorMessageVirtual = result.errorMessage;
                        }
                    } else {
                        this.errorMessageVirtual = "error.happen";
                    }
                })
            }
        },
        cancelRequestVirtualAccount: function () {
            this.$router.push({name: "deposit"});
        },
    }
}
</script>

<style scoped>

</style>
